/**
 * orga-app-api - veranstaltungen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { FunkprotokollVorlageDatenRequest } from '../model/funkprotokollVorlageDatenRequest';
// @ts-ignore
import { FunkprotokollVorlageIdentifier } from '../model/funkprotokollVorlageIdentifier';
// @ts-ignore
import { FunkprotokollVorlageRequest } from '../model/funkprotokollVorlageRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class FunkprotokollVorlageCommandService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * PostFunkprotokollVorlageAktualisierenAdmin
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VerFunkprotokollVorlageNichtGefunden: (VeranstaltungFunkprotokollVorlageNichtGefunden) * VerFunkprotokollVorlageEntfernt: (VeranstaltungFunkprotokollVorlageEntfernt) 
     * @endpoint post /api/ver/command/funkprotokoll-vorlagen/v1/aktualisieren
     * @param funkprotokollVorlageDatenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunkprotokollVorlageAktualisierenAdmin(funkprotokollVorlageDatenRequest: FunkprotokollVorlageDatenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunkprotokollVorlageIdentifier>;
    public postFunkprotokollVorlageAktualisierenAdmin(funkprotokollVorlageDatenRequest: FunkprotokollVorlageDatenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunkprotokollVorlageIdentifier>>;
    public postFunkprotokollVorlageAktualisierenAdmin(funkprotokollVorlageDatenRequest: FunkprotokollVorlageDatenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunkprotokollVorlageIdentifier>>;
    public postFunkprotokollVorlageAktualisierenAdmin(funkprotokollVorlageDatenRequest: FunkprotokollVorlageDatenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funkprotokollVorlageDatenRequest === null || funkprotokollVorlageDatenRequest === undefined) {
            throw new Error('Required parameter funkprotokollVorlageDatenRequest was null or undefined when calling postFunkprotokollVorlageAktualisierenAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/funkprotokoll-vorlagen/v1/aktualisieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunkprotokollVorlageIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funkprotokollVorlageDatenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunkprotokollVorlageAnlegenAdmin
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) 
     * @endpoint post /api/ver/command/funkprotokoll-vorlagen/v1/anlegen
     * @param funkprotokollVorlageDatenRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunkprotokollVorlageAnlegenAdmin(funkprotokollVorlageDatenRequest: FunkprotokollVorlageDatenRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunkprotokollVorlageIdentifier>;
    public postFunkprotokollVorlageAnlegenAdmin(funkprotokollVorlageDatenRequest: FunkprotokollVorlageDatenRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunkprotokollVorlageIdentifier>>;
    public postFunkprotokollVorlageAnlegenAdmin(funkprotokollVorlageDatenRequest: FunkprotokollVorlageDatenRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunkprotokollVorlageIdentifier>>;
    public postFunkprotokollVorlageAnlegenAdmin(funkprotokollVorlageDatenRequest: FunkprotokollVorlageDatenRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funkprotokollVorlageDatenRequest === null || funkprotokollVorlageDatenRequest === undefined) {
            throw new Error('Required parameter funkprotokollVorlageDatenRequest was null or undefined when calling postFunkprotokollVorlageAnlegenAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/funkprotokoll-vorlagen/v1/anlegen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunkprotokollVorlageIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funkprotokollVorlageDatenRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunkprotokollVorlageEntfernenAdmin
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VerFunkprotokollVorlageNichtGefunden: (VeranstaltungFunkprotokollVorlageNichtGefunden) * VerFunkprotokollVorlageEntfernt: (VeranstaltungFunkprotokollVorlageEntfernt) 
     * @endpoint post /api/ver/command/funkprotokoll-vorlagen/v1/entfernen
     * @param funkprotokollVorlageRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunkprotokollVorlageEntfernenAdmin(funkprotokollVorlageRequest: FunkprotokollVorlageRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunkprotokollVorlageIdentifier>;
    public postFunkprotokollVorlageEntfernenAdmin(funkprotokollVorlageRequest: FunkprotokollVorlageRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunkprotokollVorlageIdentifier>>;
    public postFunkprotokollVorlageEntfernenAdmin(funkprotokollVorlageRequest: FunkprotokollVorlageRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunkprotokollVorlageIdentifier>>;
    public postFunkprotokollVorlageEntfernenAdmin(funkprotokollVorlageRequest: FunkprotokollVorlageRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funkprotokollVorlageRequest === null || funkprotokollVorlageRequest === undefined) {
            throw new Error('Required parameter funkprotokollVorlageRequest was null or undefined when calling postFunkprotokollVorlageEntfernenAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/funkprotokoll-vorlagen/v1/entfernen`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunkprotokollVorlageIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funkprotokollVorlageRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostFunkprotokollVorlageKopierenAdmin
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * VerFunkprotokollVorlageNichtGefunden: (VeranstaltungFunkprotokollVorlageNichtGefunden) * VerFunkprotokollVorlageEntfernt: (VeranstaltungFunkprotokollVorlageEntfernt) 
     * @endpoint post /api/ver/command/funkprotokoll-vorlagen/v1/kopieren
     * @param funkprotokollVorlageRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postFunkprotokollVorlageKopierenAdmin(funkprotokollVorlageRequest: FunkprotokollVorlageRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<FunkprotokollVorlageIdentifier>;
    public postFunkprotokollVorlageKopierenAdmin(funkprotokollVorlageRequest: FunkprotokollVorlageRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<FunkprotokollVorlageIdentifier>>;
    public postFunkprotokollVorlageKopierenAdmin(funkprotokollVorlageRequest: FunkprotokollVorlageRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<FunkprotokollVorlageIdentifier>>;
    public postFunkprotokollVorlageKopierenAdmin(funkprotokollVorlageRequest: FunkprotokollVorlageRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (funkprotokollVorlageRequest === null || funkprotokollVorlageRequest === undefined) {
            throw new Error('Required parameter funkprotokollVorlageRequest was null or undefined when calling postFunkprotokollVorlageKopierenAdmin.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/ver/command/funkprotokoll-vorlagen/v1/kopieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<FunkprotokollVorlageIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: funkprotokollVorlageRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
